module.exports = __webpack_public_path__ + "static/Museo-bb19ec35a921fe599cbc0891f1951af9.jpg";